import type { BadgeProps } from "@/components/Badge";
import { ExportStatus } from "@/lib/utils/exportStatus";

export const statusToBadgeColor: Record<ExportStatus, BadgeProps["color"]> = {
  [ExportStatus.PENDING]: "pending",
  [ExportStatus.EXTRACTED]: "pending",
  [ExportStatus.TRANSFORMED]: "pending",
  [ExportStatus.LOADED]: "validated",
  [ExportStatus.COMPUTED]: "validated",
  [ExportStatus.ERROR]: "error",
  [ExportStatus.IGNORED]: "ignored",
  [ExportStatus.PREPROCESSED]: "pending",
  [ExportStatus.PROCESSING]: "quantilia_analysis",
  [ExportStatus.COMPLETED]: "validated",
  [ExportStatus.FAILED]: "error",
  [ExportStatus.SUCCESS]: "validated",
  [ExportStatus.NONE]: "validated",
};
